import styled from 'styled-components';
import Listbox from '@molecules/Listbox/Listbox';
import { rem } from 'polished';
import variables from '@styles/variables';
import Spinner from '@molecules/Spinner/Spinner';
import DesktopScrollbar from '@styles/mixins/desktopScrollbar';

export const StyledListbox = styled(Listbox)`
  ${DesktopScrollbar}
`;

export const StyledSpinner = styled(Spinner)`
  height: ${rem(80)};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const SearchParamsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(20)};
  padding: 0 ${rem(20)} ${rem(20)} ${rem(20)};
`;

export const StyledInfoBox = styled.div`
  padding: ${rem(16)};
  background: ${variables.colors.highlightBg};
  word-break: break-word;
  border-radius: ${rem(4)};
  margin: ${rem(20)};
`;

export const StyledContainer = styled.div`
  padding: ${rem(6)} ${rem(20)} ${rem(6)} ${rem(20)};
`;
